import { usePostHog } from "posthog-js/react";

export function useMaybePosthog() {
  if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePostHog();
  }
  return null;
}
